module.exports = __webpack_public_path__ + "static/media/note-template-graph.16b88aed.png";